module.exports = require("github:jspm/nodelibs-stream@0.1.0/index");